import React from 'react';

const itemStyle = {
  flexBasis: 0,
  flexGrow: 1,
  position: 'relative',
  maxWidth: '100%',
  width: '100%',
  height: 2,
};

const PasswordStrengthBarItem = ({
  score,
  itemNum,
  barColors,
}) => {
  let bgColor = barColors[0];
  
  if(score && itemNum <= score){
    bgColor = barColors[score];
  }

  return (
    <div
      style={{
        ...itemStyle,
        backgroundColor: bgColor,
        height: "4px",
        marginTop: "3px"
      }}
    />
  );
};

export default PasswordStrengthBarItem;
